import axiosInstance from './axiosInstance'
import { ApiResponse, ChatConversation, ChatRequest, PagedResponse } from '../types'

export const chatApi = {
  sendRequest: (userId: number, message?: string) =>
    axiosInstance.post<ApiResponse<ChatRequest>>(`/chat/request/${userId}`, { message }),

  acceptRequest: (requestId: number) =>
    axiosInstance.post<ApiResponse<ChatRequest>>(`/chat/accept/${requestId}`),

  rejectRequest: (requestId: number) =>
    axiosInstance.post<ApiResponse<void>>(`/chat/reject/${requestId}`),

  getConversations: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<ChatConversation>>>(`/chat/conversations?page=${page}&size=${size}`),

  getPendingRequests: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<ChatRequest>>>(
      `/chat/requests/pending?page=${page}&size=${size}`
    ),

  getFirebaseToken: () =>
    axiosInstance.get<ApiResponse<{ token: string }>>('/chat/firebase-token'),
}
